import { ChatMessages } from "../types/chat-messages";
import { pulsingDotsAnimationAfterKeyframe, pulsingDotsAnimationBeforeKeyframe, pulsingDotsAnimationMiddleKeyframe } from "./pulsing-dots-animation";

export const chatMessagesFallback: ChatMessages = {
  styles: {
    height: '0',
    width: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',

    flex: '1 1 auto',

    background: 'white',

    padding: '15px',

    display: 'flex',
    flexDirection: 'column',
    gap: '10px',

    scrollBehavior: 'smooth'
  },

  botMessage: {
    styles: {
      width: '100%',
      display: 'flex',
      alignItems: 'end',
      gap: '16px',
      position: 'relative',
      padding: '3px 0',
    },
    
    avatar: {
      styles: {
        minWidth: '53px',
        // minHeight: '53px',

        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      src: '/assets/chat-bot-message-avatar.svg'
    },
    messageCloud: {
      styles: {
        backgroundColor: '#F8F8F8',
        padding: '11px 13px',
        wordWrap: 'break-word',
        overflow: 'hidden',
        fontSize: '14px',
        fontFamily: 'Poppins, sans-serif',
        lineHeight: '138%',
        borderRadius: '8px',
        margin: 0,
      }
    },
    messageCloudP: {
      styles: {
        margin: '0'
      }
    },
    loadingAnimation: {
      styles: {
        display: 'block',
        margin: '0 10px',
        position: 'relative',
        left: '-9999px',
        width: '10px',
        height: '10px',
        borderRadius: '5px',
        backgroundColor: '#710754',
        color: '#710754',
        boxShadow: '9999px 0 0 -5px',
        animation: `${pulsingDotsAnimationMiddleKeyframe.getName()} 1.5s infinite linear`,
        animationDelay: '0.25s'
      },
      before: {
        styles: {
          content: '""',
          display: 'inline-block',
          position: 'absolute',
          top: '0',
          width: '10px',
          height: '10px',
          borderRadius: '5px',
          backgroundColor: '#710754',
          color: '#710754',
          boxShadow: '9984px 0 0 -5px',
          animation: `${pulsingDotsAnimationBeforeKeyframe.getName()} 1.5s infinite linear`,
          animationDelay: '0s'
        }
      },
      after: {
        styles: {
          content: '""',
          display: 'inline-block',
          position: 'absolute',
          top: '0',
          width: '10px',
          height: '10px',
          borderRadius: '5px',
          backgroundColor: '#710754',
          color: '#710754',
          boxShadow: '10014px 0 0 -5px',
          animation: `${pulsingDotsAnimationAfterKeyframe.getName()} 1.5s infinite linear`,
          animationDelay: '0.5s'
        }
      }
    },
    wrapper: {
      styles: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'end',
        scrollMarginTop: '10px',
        scrollMarginBottom: '10px',
      }
    },
    feedback: {
      styles: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'end',
        width: '100%'
      },
      icons: {
        styles: {
          display: 'flex',
          gap: '10px'
        },
        active: {
          styles: {
            fill: 'black'
          }
        },
        thumbUp: {
          styles: {
            width: '25px',
            height: '25px',
            padding: '0',
            border: 'none',
            background: 'none',
            cursor: 'pointer'
          },
          img: {
            styles: {
              width: '100%',
              height: '100%'
            }
          },
          activeSrc: '/assets/thumb-up-active.svg',
          inactiveSrc: '/assets/thumb-up-inactive.svg'
        },
        thumbDown: {
          styles: {
            width: '25px',
            height: '25px',
            padding: '0',
            border: 'none',
            background: 'none',
            cursor: 'pointer',
          },
          img: {
            styles: {
              width: '100%',
              height: '100%'
            }
          },
          activeSrc: '/assets/thumb-down-active.svg',
          inactiveSrc: '/assets/thumb-down-inactive.svg',
        },
        feedback: {
          styles: {
            width: '25px',
            height: '25px',
            padding: '0',
            border: 'none',
            background: 'none',
            cursor: 'pointer'
          },
          img: {
            styles: {
              width: '100%',
              height: '100%'
            }
          },
          activeSrc: '/assets/feedback-active.svg',
          inactiveSrc: '/assets/feedback-inactive.svg',
        },
        outlineColor : "#000000"
      },
      feedbackForm: {
        styles: {
          width: '100%',
          padding: '16px 24px',
          backgroundColor: '#F8F8F8',
          display: 'flex',
          alignItems: 'end',
          gap: '10px',
          borderRadius: '10px'
        },
        submitButton: {
          styles: {
            backgroundColor: '#710754',
            borderRadius: '4px',
            color: '#FFF',
            border: 'none',
            padding: '6px 10px',
            cursor: 'pointer'
          },
          text: 'Submit'
        },
        textarea: {
          styles: {
            maxWidth: '100%',
            width: '100%',
            border: 'none',
            outline: 'none !important',
            fontSize: '14px',
            fontFamily: 'Poppins, sans-serif',
            padding: '10px',
            resize: 'none',
            borderRadius: '10px',
          }
        }
      }
    }
  },

  userMessage: {
    styles: {
      width: '100%',
      display: 'flex',
      justifyContent: 'end',
      gap: '16px',
      scrollMarginTop: '10px',
      scrollMarginBottom: '10px',
    },
    messageCloud: {
      styles: {
        backgroundColor: '#710754',
        padding: '11px 13px',
        wordWrap: 'break-word',
        overflow: 'hidden',
        fontSize: '14px',
        fontFamily: 'Poppins, sans-serif',
        lineHeight: '138%',
        borderRadius: '8px',
        color: 'white',
        margin: 0,
      }
    }
  },

  suggestionShips: {
    styles: {
      display: 'flex',
      flexDirection: 'column',
      gap: '7px'
    },
    chip: {
      styles: {
        borderRadius: '8px',
        background: 'rgba(0, 155, 255, 0.06)',
        color: 'black',
        padding: '10px 16px',
        fontFamily: 'Poppins, sans-serif',
        cursor: 'pointer',
        fontSize: '13px'
      }
    },
    rowContainer: {
      styles: {
        display: 'flex',
        gap: '16px'
      }
    }
  },

  freeform: {
    styles: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },

    title: {
      styles: {
        fontFamily: 'Poppins, sans-serif',
        fontStyle: 'italic',
        fontSize: '14px',
      },

      text: 'Or ask anything below...'
    },

    icon: {
      styles: {

      },

      src: '/assets/freeform-icon.svg'
    }
  },

  sendEmailForm: {
    color: 'black',
  }
};